// WG-spezifischer Mount: die geteilte BaseSite-Bootstrap registriert das Menü auf
// '#navigation-vue'. Der WG-Header rendert stattdessen '#wg-navigation-vue', sodass
// jene Registry leer läuft und HIER die WG-eigene Navigation gemountet wird —
// ohne Änderung an WG.BaseSite/bootstrap.js und ohne Doppel-Mount.
import { createApp } from 'vue'
import WGNavigation from './components/WGNavigation.vue'
import { resetAllConsent } from '../../../../WG.BaseSite/Resources/Private/JavaScript/consent.js'

function mountWGNavigation() {
	document.querySelectorAll('#wg-navigation-vue').forEach((el) => {
		if (el._vueInstance) return
		const app = createApp(WGNavigation, {
			navigationItems: el.getAttribute('data-navigation'),
			logo: el.getAttribute('data-logo'),
			logoLight: el.getAttribute('data-logo-light'),
		})
		el._vueInstance = app.mount(el)
	})
}

// Logo-Schwelle beim Scrollen. Live (app-min.js): `checkScrollPosition()` gibt
// ab scrollTop > 120 false zurück und setzt dann `.scroll` auf den Logo-Link.
// Ab hier macht CSS den Rest (app.css .wg-logo.is-scrolled) — bewusst KEIN
// src-Tausch per JS mehr: der sprang hart um, während live die Breite des
// Links in 0,5 s animiert und die Wortmarke dabei mitskaliert.
// Dadurch entfällt auch die Sonderbehandlung für das geöffnete Menü: die
// Klasse fasst das src-Attribut nicht an, das die Navigation dort umsetzt.
const LOGO_SCROLL_THRESHOLD = 120

function initHeaderScrollLogo() {
	const logo = document.querySelector('header a.wg-logo')
	if (!logo || logo._wgScrollLogo) return
	logo._wgScrollLogo = true
	const sync = () => {
		logo.classList.toggle('is-scrolled', window.scrollY > LOGO_SCROLL_THRESHOLD)
	}
	window.addEventListener('scroll', sync, { passive: true })
	sync()
}

// "Datenschutz-Einstellungen" im Footer = Widerruf nach Art. 7 Abs. 3 DSGVO.
// Muss so einfach sein wie die Erteilung, also EIN Klick, und muss BEIDE Zwecke
// treffen: die Matomo-Entscheidung (localStorage) und die gemerkten
// Embed-Freigaben der Sitzung (sessionStorage). Der Reload danach ist Teil des
// Widerrufs — sonst bliebe ein bereits geladenes iframe stehen und würde
// weiter Daten an den Anbieter senden.
function initConsentResetLinks() {
	document.querySelectorAll('[data-cookie-settings]').forEach((a) => {
		if (a._wgCookie) return
		a._wgCookie = true
		a.addEventListener('click', (e) => {
			e.preventDefault()
			resetAllConsent()
			window.location.reload()
		})
	})
}

function initAll() {
	mountWGNavigation()
	initHeaderScrollLogo()
	initConsentResetLinks()
}

document.addEventListener('DOMContentLoaded', () => {
	initAll()
	// Spät injiziertes Markup (z.B. Neos-Backend) ebenfalls mounten
	if (document.body) {
		new MutationObserver(initAll).observe(document.body, {
			childList: true,
			subtree: true,
		})
	}
})
window.addEventListener('load', initAll)
